module.exports = __webpack_public_path__ + "img/banner-princiapal.0de37182.svg";